module.exports = __webpack_public_path__ + "media/images/athletes/3531-bf1bc891696dd150325e243ed3b64744.png";